<template>
  <path
    d="M17.991 1.8C17.991 0.81 17.19 0 16.2 0H1.8C0.81 0 0 0.81 0 1.8V12.6C0 13.59 0.81 14.4 1.8 14.4H14.4L18 18L17.991 1.8ZM16.2 1.8V13.653L15.147 12.6H1.8V1.8H16.2ZM3.6 9H14.4V10.8H3.6V9ZM3.6 6.3H14.4V8.1H3.6V6.3ZM3.6 3.6H14.4V5.4H3.6V3.6Z"
  />
</template>
